module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/imgadvisor_spotlight_tablet_02@2x-a9ed8ac7ce55ec7aec503c853300c6f9.jpg";